import Config from "../config/config";
import axios from "axios";

const { baseURL } = Config.API;

const getBacklinks = (queryParams) => {
  return axios({
    method: 'GET',
    baseURL,
    url: '/backlinks',
    params: queryParams
  });
};

const addBacklink = (data) => {
  return axios({
    method: 'POST',
    baseURL,
    url: '/backlinks',
    data,
  });
};

const deleteBacklinks = (ids) => {
  return axios({
    method: 'DELETE',
    baseURL,
    url: `/backlinks/`,
    data: {
      ids
    }
  });
};

export default {
  getBacklinks,
  addBacklink,
  deleteBacklinks
};
